import { render } from "./votingList.vue?vue&type=template&id=4b750bde"
import script from "./votingList.vue?vue&type=script&lang=js"
export * from "./votingList.vue?vue&type=script&lang=js"

import "./votingList.vue?vue&type=style&index=0&id=4b750bde&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__